import Splide from "@splidejs/splide";

if (document.getElementsByClassName('js-carousel')[0]) {
    initCarousel();
}

if (document.getElementsByClassName("js-testimonials")[0]) {
  initTestimonials();
}

function initCarousel() {

    var splide = new Splide( '.js-carousel', {
        // type   : 'loop',
        // drag   : 'free',
        snap   : true,
        perPage: 3,
        // cover      : true,
        // heightRatio: 0.25,
        focus  : 'left',
        lazyLoad: 'nearby',
        pagination: false,
        gap: '1rem',
        breakpoints: {
            960: {
                perPage: 2,
            },
            640: {
                perPage: 1,
            },
        },
    } );

    splide.mount();
}

function initTestimonials() {
  var testimonials = new Splide(".js-testimonials", {
    // type   : 'loop',
    // drag   : 'free',
    snap: true,
    perPage: 1,
    // cover      : true,
    // heightRatio: 0.25,
    focus: "left",
    lazyLoad: "nearby",
    pagination: false,
    gap: "1rem",
  });

  testimonials.mount();
}